import { useInputErrorMessage } from "crossdock/common/useInputErrorMessage";

export function useLinkContainerError() {
  return useInputErrorMessage();
}
